import Checkout from '@/page/Checkout';
import Products from '@/page/Products';
import { CustomerForm, MercadoPagoForm } from '@/page/Checkout/components';

const landingpageRoute = {
  path: '/:companiesSlug',
  children: [
    {
      path: 'products',
      element: <Products />,
    },
    {
      path: 'checkout',
      element: <Checkout />,
      children: [
        {
          path: 'customer',
          element: <CustomerForm />,
        },
        {
          path: 'payment',
          element: <MercadoPagoForm />,
        },
      ],
    },
  ],
};

export default landingpageRoute;
